<template>
  <div class="selectSignContainer">
    <breadcrumb>
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/personal/sign/detail?id=${$route.query.id}` }">签约详情</el-breadcrumb-item>
        <el-breadcrumb-item>查看合同</el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
  
    <div class="tabContainerSign">
      <span class="downloadSign" @click="downLoad">下载合同</span>
      <div class="moreSign" v-if="showMoreBtn">
        <div class="selectMore">查看更多</div>
        <div class="allSignContainer">
          <ul class="allSign">
            <li
              class="allSignItem ellipsis"
              v-for="(item,index) in fileArray"
              :key="index"
              @click="changeShowTab(item)"
            >{{item.fileName}}</li>
          </ul>
        </div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
        <el-tab-pane
          v-for="(item,index) in fileArray"
          :key="index"
          :label="item.fileName"
          :name="item.id"
          :url="item.filePath"
          :item="item"
        >
          <div class="page">
            <span class="cursorPointer up" @click="toTop(item.id)">
              <img class="nor" src="../../../assets/images/sign/up_icon_nor.png" alt srcset>
              <img class="hov" src="../../../assets/images/sign/up_icon_hov_pre.png" alt srcset>
            </span>
            <span class="cursorPointer up" @click="toBottom(item.id)">
              <img class="nor" src="../../../assets/images/sign/down_icon_nor.png" alt srcset>
              <img class="hov" src="../../../assets/images/sign/down_icon_hov_pre.png" alt srcset>
            </span>
          </div>
          <div :id="item.id" class="pdfCon"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import browser from "@lib/getBrowser.js";
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util.js";
import {mapState} from "vuex"
export default {
  data() {
    return {
      activeName: "",
      currentItem: null,
      fileArray: [],
      showMoreBtn: false,
      downloadSignUrl:""
    };
  },
  components: {
    Breadcrumb
  },
   computed: {
    ...mapState(['curState'])
  },
  mounted() {
    this.getFiled();
    $(window).resize(() => {
      this.judgeMoreShow();
    });
  },
  methods: {
    //下载合同
    downLoad() {
      BaseApi.createRpcToken(
        "/file/downloadContract",
        { id: this.$route.query.id, fileId: this.currentItem.id },
        "get",
        true,
        false,
        true,
        "blob"
      ) .then((data) => {
        let fileDatas=data.data;
          const blob = new Blob([fileDatas], {type: fileDatas.type || data.headers.content-type}); // 后端返回的blob数据， type文件的类型
          const fileName = `${ this.currentItem.fileName||new Date().valueOf()}.${this.currentItem.fileFormat}`; // 自定义文件名
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click(); 
          window.URL.revokeObjectURL(link.href);
          // console.log("下载合同",data,fileDatas)
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    changeShowTab(item) {
      this.activeName = item.id;
      this.activeChange("", item);
    },
    getFiled() {
      BaseApi.createRpcToken("/file/list", {
        id: this.$route.query.id || 1
      })
        .then(
          data => {
            this.fileArray = data.datas.list;
            this.activeChange("", this.fileArray[0]);
            this.judgeMoreShow();
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeMoreShow() {
      let interValFlag = setInterval(() => {
        if ($(".el-tabs__nav-wrap").width()) {
          clearInterval(interValFlag);
          if ($(".el-tabs__nav-next")[0]) {
            this.showMoreBtn = true;
          } else {
            this.showMoreBtn = false;
          }
        }
      }, 10);
    },
    toTop(id) {
      $(`#${id}`).scrollTop(0);
    },
    toBottom(id) {
      $(`#${id}`).scrollTop($(`#${id}`)[0].scrollHeight);
    },
    activeChange(node, item) {
      this.currentItem = (node && node.$attrs.item) || item;
      this.activeName = this.currentItem.id;
      if (!this.currentItem.isAdd) {
        this.currentItem.isAdd = true;
        this.$nextTick(() => {
          this.getPdfToImage(this.currentItem.filePath, this.currentItem.id);
        });
      }
    },
    getPage(page, index, id) {
      var scale = 1; //缩放倍数，1表示原始大小
      var viewport = page.getViewport(scale);
      var canvas = document.getElementById("canvas" + index + id);
      var canvasFather = canvas.parentNode;
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvasFather.style.width = viewport.width + "px";
      canvasFather.style.height = viewport.height + "px";
      canvasFather.style.margin = "10px auto";
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      page.render(renderContext).promise.then(() => {
        this.loadedPageCount++;
      });
    },
    getPdfToImage(url, id) {
      let container = document.getElementById(id);
      container.style.display = "block";
      let _this = this;
      url =
        url ||
        "http://xcon-dev.oss-cn-beijing.aliyuncs.com/0120190110001451/20190110/50.pdf";
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.totalPage = pdf.numPages;
        for (let i = 1; i <= _this.totalPage; i++) {
          $(container).append(
            `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas><p class="pdfPageFlag">${i}/${
              _this.totalPage
            }</div>`
          );
          pdf.getPage(i).then(page => {
            _this.getPage(page, i, id);
          });
        }
        $(".canvasBoxFlag").addClass("canvasBox");
        $(".pdfPageFlag").addClass("pdfPage");
      });
    }
  },
  watch:{
    "curState"(data){
      this.$router.replace("/personal/home")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scope>
.selectSignContainer {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  .tabContainerSign {
    height: calc(100% - 40px);
    box-sizing: border-box;
    padding-top: 20px;
    position: relative;
    .el-tabs__header {
      max-width: calc(100% - 120px);
    }
    .moreSign {
      &:hover {
        .allSignContainer {
          display: block;
        }
      }
    }
    .allSignContainer {
      display: none;
      position: absolute;
      top: 53px;
      z-index: 10;
      width: 100%;
      .allSign {
        opacity: 0.8;
        background: #ffffff;
        border: 1px solid #e4e8eb;
        padding-top: 10px;
        .allSignItem {
          display: inline-block;
          cursor: pointer;
          width: 132px;
          font-size: 12px;
          line-height: 32px;
          padding: 0 20px;
          &:hover {
            color: #e88078;
          }
        }
      }
    }
    .selectMore {
      position: absolute;
      cursor: pointer;
      width: 100px;
      height: 30px;
      line-height: 32px;
      right: 0;
      top: 20px;
      border: 1px solid #e29999;
      font-size: 12px;
      color: #e29999;
      text-align: center;
      z-index: 2;
    }
    .el-tabs {
      height: 100%;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 33px;
    }
    .el-tabs__item {
      height: 33px;
      line-height: 30px;
      font-size: 12px;
      color: #646464;
      background: #f5f5f5;
      border-top: 3px solid #f5f5f5;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item:hover {
      color: #e88078;
    }
    .el-tabs--card > .el-tabs__header {
      border-bottom: 1px solid #e4e8eb;
    }
    .el-tabs__item.is-active {
      color: #e88078;
      background-color: #ffffff;
      border-top: 3px solid #e88078;
    }
    .canvasBox {
      position: relative;
      canvas {
        border-radius: 18px;
      }
    }
    .page {
      position: fixed;
      right: 50px;
      width: 60px;
      text-align: center;
      bottom: 81px;
      z-index: 20;
      span {
        margin-top: 6px;
        display: block;
      }
      .up {
        img {
          margin: 0 auto;
        }
        .nor {
          display: block;
        }
        .hov {
          display: none;
        }
        &:hover {
          .nor {
            display: none;
          }
          .hov {
            display: block;
          }
        }
      }
    }
    .pdfPage {
      position: absolute;
      top: 24px;
      right: 24px;
      padding: 3px 16px;
      font-size: 18px;
      font-weight: 200;
      color: #fff;
      line-height: 25px;
      border-radius: 8px;
      background: #9b9b9b;
    }
    .el-tabs__content {
      box-sizing: border-box;
      border: 1px solid #e4e8eb;
      border-top: none;
      padding: 10px;
      height: calc(100% - 48px);
      background: #e3e9ef;
      // overflow: auto;
      width: 100%;
      position: relative;
      .el-tab-pane {
        height: 100%;
        .pdfCon {
          box-sizing: border-box;
          height: calc(100% - 10px);
          margin: 0 auto;
          margin-top: 10px;
          overflow: auto;
        }
      }
    }
  }
  .downloadSign{
    position: absolute;
    top:20px;
    right: 10px;
    color:#e29999;
    cursor: pointer;
  }
}
</style>
